import { useCallback, useState } from 'react';

function usePageLoading(initialLoading = false) {
  const [isLoading, setIsLoading] = useState(initialLoading);

  const withLoading = useCallback(async (asyncFn) => {
    setIsLoading(true);
    try {
      return await asyncFn();
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { isLoading, setIsLoading, withLoading };
}

export default usePageLoading;
